import * as api from "../../../api";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { ALERT } from "../../../constants/actionTypes";

import Project from "../Project/Project";

import Pdf from "../../../images/documents/pdf.png";

import "./Completed.css";
import { KeyboardArrowDown } from "@material-ui/icons";

const Completed = ({ user, setUser }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [quotes, setQuotes] = useState([]);
  const [quote, setQuote] = useState({});
  const [skip, setSkip] = useState(0);
  const [showDetails, setShowDetails] = useState(false);

  console.log(quotes);

  const getQuotes = useCallback(async () => {
    try {
      const { data } = await api.getQuotes({
        status: { status: "approved", creator: user._id },
        skip: 0,
      });
      setQuotes(data);
    } catch (error) {
      if (error.response)
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: error.response.data.message,
            duration: 5000,
            display: true,
          },
        });
      else
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: "An unexpected error occurred",
            duration: 5000,
            display: true,
          },
        });
    } finally {
      setLoading(false);
    }
  }, [user, dispatch]);

  const handleNextPage = async () => {
    try {
      const { data } = await api.getQuotes({
        status: { status: "approved", creator: user._id },
        skip: skip + 20,
      });
      setQuotes([...quotes, ...data]);
      setSkip((skip) => skip + 20);
    } catch (error) {
      if (error.response)
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: error.response.data.message,
            duration: 5000,
            display: true,
          },
        });
      else
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: "An unexpected error occurred",
            duration: 5000,
            display: true,
          },
        });
    }
  };

  const handleDetails = (quote) => {
    setQuote(quote);
    setShowDetails(true);
  };

  useEffect(() => {
    if (showDetails) {
      document.getElementsByTagName("BODY")[0].style.overflow = "hidden";
    } else {
      document.getElementsByTagName("BODY")[0].style.overflow = "auto";
    }
  }, [showDetails]);

  useEffect(() => {
    if (quotes.length === 0) getQuotes();
    else setLoading(false);
  }, [getQuotes, quotes]);

  return (
    <>
      {showDetails && (
        <Project
          showDetails={showDetails}
          setShowDetails={setShowDetails}
          quote={quote}
          setQuotes={setQuotes}
          user={user}
          setUser={setUser}
          completed
        />
      )}
      <div className="completed">
        <h2 className="mb-40 py-20 font-subhead">Completed Projects</h2>
        <div className="d-flex flex-wrap">
          {loading ? (
            <div className="loader mx-auto">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          ) : (
            <>
              {quotes.length < 1 && (
                <div className="font-bolder font-bigger text-center w-100">
                  No ongoing project
                </div>
              )}
              {quotes.map((quote, index) => (
                <div
                  className="client__file d-flex flex-column align-center mr-20 mb-20 box-shadow-lg p-20"
                  key={quote.projectName.concat(index)}
                >
                  <img src={Pdf} alt="" />
                  <div className="d-flex flex-column align-center justify-center mt-20">
                    <span className="text-capitalise font-heavy font-sm">
                      {quote.projectName}
                    </span>
                    {quote.status === "approved" && (
                      <span
                        style={{ color: "rgb(0, 172, 0)" }}
                        className="font-bolder"
                      >
                        Completed
                      </span>
                    )}
                  </div>
                  <div className="client__file__btn d-flex justify-between mt-20 w-100">
                    <button
                      className="font-heavy border-1 outline-0 p-5 w-100"
                      onClick={() => handleDetails(quote)}
                    >
                      Details
                    </button>
                  </div>
                </div>
              ))}
            </>
          )}
          {!loading && quote > 19 && (
            <div
              className="d-flex justify-center p-20 pointer"
              onClick={handleNextPage}
            >
              <div className="d-flex align-center border-1 px-20 py-5 curved-20">
                <span className="font-bold">View More</span>
                <KeyboardArrowDown className="ml-5" fontSize="large" />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Completed;
